exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news-item[data-v-756de00d]{position:relative;margin-bottom:30px;border-radius:5px}.news-item img[data-v-756de00d]{width:100%;height:auto}.news-item h2[data-v-756de00d]{max-height:95px;-webkit-line-clamp:2}.news-item h2[data-v-756de00d],.news-item p[data-v-756de00d]{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical}.news-item p[data-v-756de00d]{max-height:90px;-webkit-line-clamp:3}.news-item .description[data-v-756de00d]{background-color:#f8fdfd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-756de00d","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/news-card.vue
// module id = cdln
// module chunks = 0